import { Component } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { ContextInteractionService } from '../../services/context-interaction.service';


@Component({
    selector: 'app-yesno-toggle',
    templateUrl: './yesnotoggle.component.html',
    styleUrls: ['./yesnotoggle.component.scss'],
    standalone: false
})
export class YesNoToggleComponent extends BaseControlComponent {
    static componentName = 'YesNoToggleComponent';


    public toggleActive(): void {
        this.change();
        this.setContextValue(!this.contextValue);
    }

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    public ngOnInit(): void {   
        super.ngOnInit();
        this.change();
        this.setContextValue(false);        
    }
}
